const questions = [
  {
    question: 'What sort of funeral planning help do you need?',
    fieldName: 'q_preneed',
    answers: ['Immediate help', 'Future pre-planning'],
    help:
      'Pre-planning means making arrangements for a funeral someday in the future.',
    page: 'preneed',
  },
  {
    question: 'Who are you planning for?',
    fieldName: 'q_who',
    answers: ['Myself', 'Someone Else'],
    page: 'who',
  },
  {
    question: 'Religious guidelines',
    fieldName: 'q_religion',
    answers: [
      'Christian',
      'Christian (Catholic)',
      'Christian (Eastern Orthodox)',
      'Christian (LDS)',
      'Jewish',
      'Muslim',
      'Hindu',
      'Buddhist',
      'Other',
    ],
    page: 'religion',
  },
  {
    question: 'What type of service?',
    fieldName: 'q_traditional',
    answers: ['Traditional', 'Unique'],
    page: 'traditional',
  },
  {
    question: 'What are your budget considerations?',
    fieldName: 'q_budget',
    answers: ['Open Budget', 'Moderate Budget', 'Tight Budget'],
    page: 'budget',
  },
  {
    question: 'What are your desired preferences?',
    fieldName: 'q_body',
    answers: ['Burial', 'Cremation', 'Donate to Science', 'Other'],
    page: 'body',
  },
];

export default questions;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/Questionnaire/data/questions.js